export default function LogIcon() {
  return (
    <svg
      width="17"
      height="21"
      viewBox="0 0 17 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.5 13.25H11.5M5.5 10.25H11.5M11.5002 2.75H15.25C15.4489 2.75 15.6397 2.82902 15.7803 2.96967C15.921 3.11032 16 3.30109 16 3.5V19.25C16 19.4489 15.921 19.6397 15.7803 19.7803C15.6397 19.921 15.4489 20 15.25 20H1.75C1.55109 20 1.36032 19.921 1.21967 19.7803C1.07902 19.6397 1 19.4489 1 19.25V3.5C1 3.30109 1.07902 3.11032 1.21967 2.96967C1.36032 2.82902 1.55109 2.75 1.75 2.75H5.4998M4.75 5.75V5C4.75 4.00544 5.14509 3.05161 5.84835 2.34835C6.55161 1.64509 7.50544 1.25 8.5 1.25C9.49456 1.25 10.4484 1.64509 11.1517 2.34835C11.8549 3.05161 12.25 4.00544 12.25 5V5.75H4.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
